var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"vertical-gallery"}},_vm._l((_vm.images),function(image){return _c('div',{key:image.id},[_c('img',{staticClass:"img-fluid my-2",attrs:{"src":'img/pastor/' + image.name}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }